// export const API_BASE_URL = "https://dev.dse-cc-api.com";
// // export const FULL_API_BASE_URL = "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1";
// export const FULL_API_BASE_URL =
//   "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1";
// // "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/get-classes/";
// // export const API_BASE_URL = "https://live.dse-cc-api.com";



export const API_BASE_URL = "https://dev.dse-cc-api.com";
// export const FULL_API_BASE_URL = "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1";
// export const FULL_API_BASE_URL = "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1";
// "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/get-classes/";
// export const API_BASE_URL = "https://live.dse-cc-api.com";
 
// export const API_BASE_URL = "https://prism-dev.dse-cc-api.com";
export const FULL_API_BASE_URL = "https://prism-dev.dse-cc-api.com/prism/api/v1";



// export const API_BASE_URL = "http://127.0.0.1:8000";
// export const FULL_API_BASE_URL = "http://127.0.0.1:8000/prism/api/v1";